import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

const appointmentPayload = (payload = {}) => ({
  pet_id: Number(payload.pet_id),
  doctor_id: Number(payload.doctor_id),
  appointment_date: payload.appointment_date,
  start_time: payload.start_time,
  end_time: payload.end_time,
  appointment_notes: payload.appointment_notes || "",
  priority: payload.priority || "routine",
  triage_reason: payload.triage_reason || null,
  triage_notes: payload.triage_notes || null,
  resource_id: payload.resource_id || null,
  ...(payload.status ? { status: payload.status } : {})
});

export const appointmentApi = {
  async list(params = {}) {
    const response = await apiClient.get("/appointments", { params });
    return {
      data: unwrapList(response.data),
      meta: unwrapMeta(response.data)
    };
  },

  async count(params = {}) {
    const response = await apiClient.get("/appointments/count", { params });
    return unwrapEnvelope(response.data, { count: 0 });
  },

  async get(id) {
    const response = await apiClient.get(`/appointments/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async create(payload) {
    const response = await apiClient.post("/appointments", appointmentPayload(payload));
    return unwrapEnvelope(response.data, null);
  },

  async request(payload) {
    const response = await apiClient.post("/appointments/requests", payload);
    return unwrapEnvelope(response.data, null);
  },

  async update(id, payload) {
    const response = await apiClient.put(`/appointments/${id}`, {
      appointment_date: payload.appointment_date,
      start_time: payload.start_time,
      end_time: payload.end_time,
      appointment_notes: payload.appointment_notes || "",
      ...(payload.priority ? { priority: payload.priority } : {}),
      ...(payload.triage_reason !== undefined ? { triage_reason: payload.triage_reason || null } : {}),
      ...(payload.triage_notes !== undefined ? { triage_notes: payload.triage_notes || null } : {}),
      ...(payload.status ? { status: payload.status } : {})
    });
    return unwrapEnvelope(response.data, null);
  },

  async updateStatus(id, status, payload = {}) {
    const response = await apiClient.patch(`/appointments/${id}/status`, {
      status,
      ...(payload.priority ? { priority: payload.priority } : {}),
      ...(payload.triage_reason !== undefined ? { triage_reason: payload.triage_reason || null } : {}),
      ...(payload.triage_notes !== undefined ? { triage_notes: payload.triage_notes || null } : {})
    });
    return unwrapEnvelope(response.data, null);
  },

  async cancel(id) {
    const response = await apiClient.delete(`/appointments/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async checkAvailability(params) {
    const response = await apiClient.get("/appointments/availability", { params });
    return unwrapEnvelope(response.data, { available: true });
  }
};
